<div fxLayout="row" fxLayoutAlign="center center" class="Title">
    <mat-icon 
        fxLayoutAlign="center center" (click)="back()" class="Title__back" 
        fxLayout="row" fxLayoutAlign="center"
        *ngIf="isBack != 'false'"
        >
        arrow_back</mat-icon>
        <mat-card-title>{{ "nav.sub" + title | translate }}</mat-card-title>
</div>